export const CURRENT_LANGUAGE = "CURRENT_LANGUAGE";

export type AlignType = "left" | "center" | "right";

export type ImageProps = {
  alt: string;
  width: number;
  height: number;
};
